export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let s = val == null ? "" : String(val);
    if (s.includes('"')) s = s.replace(/"/g, '""');
    return `"${s}"`;
  };

  // header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // data rows
  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Given an array of transactions (already filtered by store/date),
 * filters out those with zero discount, builds a CSV, and triggers download.
 *
 * @param {Object[]} transactions
 * @param {string}   [brandName="Angels Pizza"]
 * @param {string}   [fileName="Transactions_Discount_Value_Time_of_Day.csv"]
 */
export function exportDiscountTransactionsCSV(
  transactions,
  brandName = "Angels Pizza",
  fileName = "Transactions_Discount_Value_Time_of_Day.csv"
) {
  if (!Array.isArray(transactions)) {
    console.error(
      "exportDiscountTransactionsCSV: need an array of transactions"
    );
    return;
  }

  // 1) exclude any tx with zero discount
  const withDiscount = transactions.filter(
    (tx) => Number(tx.discount_amount || 0) > 0
  );

  // 2) map into flat objects matching CSV columns
  const rows = withDiscount.map((tx) => {
    const date = new Date(tx.tran_date).toISOString().split("T")[0];
    const store = tx.store_code.split("_")[1] || tx.store_code;
    return {
      Brand: brandName,
      Store: store,
      Date: date,
      "Discount Name": tx.discount_name || "",
      "Discount Amount": Number(tx.discount_amount || 0).toFixed(2),
    };
  });

  // 3) convert to CSV string
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportDiscountTransactionsCSV: nothing to export");
    return;
  }

  // 4) trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
